// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3GrG-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1sVSL","obliqueLine":"membershipbadge_obliqueLine__3lNxP"};